import { render } from "./App.vue?vue&type=template&id=09419d0a"
const script = {}

import "./App.vue?vue&type=style&index=0&id=09419d0a&lang=css"

import exportComponent from "../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.13_vue@3.5.13_webpack@5.97.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__